export default [{
  id: 1,
  show_from: 'lg',
  parent_id: 0,
  section: 'left_menu',
  item: 'Cost Allocation',
  action_type: 'url',
  action: 'Cost Allocation',
  is_company_admin: false,
}];
